import { Card } from "../Card";

import "swiper/swiper.min.css";
import "swiper/css/a11y";
import { Slider } from "../Slider";
import { StrapiStore } from "~/shared-types";
import { getFormattedImageAttributes } from "~/utils/getImageAttributes";
import { getRoute } from "~/utils/getRoute";

type StoresSliderProps = {
  stores: StrapiStore[] | null;
  className?: string;
};

function StoresSlider({ stores, className }: StoresSliderProps) {
  if (!stores) return null;
  const uniqueStores = stores.filter(
    (store, index, self) => index === self.findIndex((t) => t.id === store.id)
  );
  return (
    <div className={className}>
      <Slider
        elements={uniqueStores.map((store) => {
          const { id } = store;
          return {
            id,
            component: (
              <Card
                key={id}
                href={getRoute("/stores/:id", { id })}
                className="w-full"
              >
                {store.attributes.storeImage && (
                  <Card.Image
                    {...getFormattedImageAttributes(
                      store.attributes.storeImage.data,
                      "large",
                      { altFallback: store.attributes.name }
                    )}
                    className="aspect-square w-full object-cover"
                  />
                )}
                {store.attributes.shownAddress?.city && (
                  <Card.Location>
                    {store.attributes.shownAddress.city}
                  </Card.Location>
                )}
                <Card.Title>{store.attributes.name}</Card.Title>
              </Card>
            ),
          };
        })}
      />
    </div>
  );
}

export { StoresSlider };
